import * as Turbo from "@hotwired/turbo"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import Lenis from "lenis"

import "$styles/index.css"

// All webfonts (Bricolage Grotesque, DM Sans, IBM Plex Mono) are self-hosted
// via frontend/fonts/fonts.css, imported from index.css — no CDN, no @fontsource.

import "./controllers"

// Boot handshake for the reveal failsafe (see _head.erb + .reveal-failsafe in
// site.css). Reaching this line means the bundle downloaded, parsed, and the
// controllers module loaded, so the head timer must NOT force content visible.
// If the bundle ever fails to boot, this never runs and the failsafe fires.
document.documentElement.classList.add("reveal-booted")

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger)

// Reduced motion detection
const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

// GSAP defaults
if (prefersReducedMotion) {
  gsap.defaults({ duration: 0 })
} else {
  gsap.defaults({ ease: "power2.out" })
}

// Expose GSAP globals for controllers
window.__gsap = gsap
window.__ScrollTrigger = ScrollTrigger

// Lenis smooth scrolling (skip if reduced motion)
let lenis = null

if (!prefersReducedMotion) {
  lenis = new Lenis({ duration: 0.8 })

  lenis.on("scroll", ScrollTrigger.update)

  gsap.ticker.add((time) => lenis.raf(time * 1000))
  gsap.ticker.lagSmoothing(0)
}

window.__lenis = lenis

// Turbo Drive
Turbo.start()
Turbo.config.drive.progressBarDelay = 9999

document.addEventListener("turbo:load", () => {
  lenis?.start()
  lenis?.scrollTo(0, { immediate: true })

  // Delay ScrollTrigger refresh until after Stimulus controllers have
  // connected via MutationObserver (async). Controllers manage their own
  // ScrollTrigger cleanup in disconnect(), so no global kill is needed.
  requestAnimationFrame(() => {
    ScrollTrigger.refresh()
  })
})
